import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AnimatedSection from "../../components/base/AnimatedSection";
import { blogArticles } from "../../mocks/blog";

export default function BlogPage() {
  const [featured, ...rest] = blogArticles;

  return (
    <div className="min-h-screen flex flex-col font-body bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 px-6" style={{ backgroundColor: "#F4F4F4" }}>
        <div className="max-w-7xl mx-auto">
          <AnimatedSection>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-8 h-0.5" style={{ backgroundColor: "#E8150C" }}></div>
              <span className="font-body text-brand-red text-sm font-medium tracking-widest uppercase">
                Recursos y guias
              </span>
            </div>
            <h1 className="font-heading font-black text-brand-black leading-none mb-4"
              style={{ fontSize: "clamp(2.2rem, 5vw, 4rem)" }}>
              BLOG — GESTION DEPORTIVA
            </h1>
            <p className="font-body text-brand-gray-mid text-base max-w-xl">
              Guias practicas y recursos para organizadores que quieren profesionalizar su competicion.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Featured article */}
      <section className="py-14 px-6">
        <div className="max-w-7xl mx-auto">
          <AnimatedSection>
            <Link
              to={`/blog/${featured.slug}`}
              className="group grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-gray-100 hover:border-brand-red transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-64 lg:h-full min-h-[320px] overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ objectPosition: featured.imagePosition }}
                />
              </div>
              <div className="p-10 flex flex-col justify-center bg-white">
                <span className="font-body text-xs font-medium text-brand-red tracking-widest uppercase mb-3">
                  {featured.category}
                </span>
                <h2 className="font-heading font-bold text-brand-black text-2xl leading-tight mb-4 tracking-tight">
                  {featured.title}
                </h2>
                <p className="font-body text-brand-gray-mid text-sm leading-relaxed mb-6">
                  {featured.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="font-body text-brand-gray-mid text-xs">{featured.date} · {featured.readTime}</span>
                  <span className="font-body text-brand-red text-sm font-medium group-hover:underline whitespace-nowrap">
                    Leer articulo →
                  </span>
                </div>
              </div>
            </Link>
          </AnimatedSection>
        </div>
      </section>

      {/* Rest of articles */}
      <section className="pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {rest.map((article, i) => (
              <AnimatedSection key={article.slug} delay={i * 100}>
                <Link
                  to={`/blog/${article.slug}`}
                  className="group bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-brand-red transition-all duration-300 cursor-pointer flex flex-col h-full"
                >
                  <div className="w-full h-52 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      style={{ objectPosition: article.imagePosition }}
                    />
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <span className="font-body text-xs font-medium text-brand-red tracking-widest uppercase mb-3">
                      {article.category}
                    </span>
                    <h3 className="font-heading font-bold text-brand-black text-xl leading-tight mb-3 tracking-tight flex-1">
                      {article.title}
                    </h3>
                    <p className="font-body text-brand-gray-mid text-sm leading-relaxed mb-5">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between mt-auto">
                      <span className="font-body text-brand-gray-mid text-xs">{article.date} · {article.readTime}</span>
                      <span className="font-body text-brand-red text-sm font-medium group-hover:underline whitespace-nowrap">
                        Leer mas →
                      </span>
                    </div>
                  </div>
                </Link>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
